var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplianceSettingEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2016_13044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9943 140C108.65 140 139.989 108.661 139.989 70.0057C140 31.3389 108.661 0 69.9943 0C31.3389 0 0 31.3389 0 69.9943C0 108.661 31.3389 140 69.9943 140Z",
    fill: "#E3F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.486 40.5809H45.0546V68.0123H72.486V40.5809Z",
    fill: "#087A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4914 68.024H99.9229V40.5926H72.4914V68.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8757 48.4071C77.5033 48.4071 79.6326 50.5364 79.6326 53.164C79.6326 55.7916 77.5033 57.9209 74.8757 57.9209",
    fill: "#087A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8729 57.9272V48.4134H72.4831V57.9272H74.8729Z",
    fill: "#087A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4914 95.4531H99.9229V68.0217H72.4914V95.4531Z",
    fill: "#074D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1076 87.2205C67.48 87.2205 65.3507 85.0912 65.3507 82.4636C65.3507 79.8359 67.48 77.7067 70.1076 77.7067",
    fill: "#074D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1041 77.7026V87.2164H72.4939V77.7026H70.1041Z",
    fill: "#074D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4448 65.6339C81.4448 63.0062 83.5741 60.877 86.2017 60.877C88.8293 60.877 90.9586 63.0062 90.9586 65.6339",
    fill: "#074D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9586 65.6339H81.4448V68.0237H90.9586V65.6339Z",
    fill: "#074D43"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8091 89.8828L42.5532 111.611L50.0319 105.848L51.4592 107.7L58.9951 101.893L57.5678 100.041L64.2817 94.8671L47.5375 73.1387L39.8786 79.0407L38.4249 77.1543L30.889 82.9615L32.3427 84.848L25.8091 89.8828ZM30.887 82.9628C29.2787 80.8788 29.6751 77.9001 31.7478 76.2918C33.8317 74.6835 36.8105 75.0799 38.4187 77.1525L30.887 82.9628ZM58.9971 101.892C60.6054 103.976 60.209 106.954 58.1363 108.563C56.0523 110.171 53.0736 109.775 51.4653 107.702L58.9971 101.892ZM54.9083 78.7717C56.9923 77.1634 59.971 77.5598 61.5793 79.6324C63.1871 81.7159 62.7913 84.6936 60.7201 86.3022L60.7244 86.3077L58.8314 87.7664L53.0242 80.2306L54.9117 78.7761L54.9083 78.7717Z",
    fill: "#087A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2016_13044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceSettingEmptyIcon);
export default __webpack_public_path__ + "static/media/compliance-setting-empty-icon.16b9db233637c1d153f93476ff3392db.svg";
export { ForwardRef as ReactComponent };